var map = {
	"./boots.jpg": 665,
	"./buysure.png": 805,
	"./lyra.png": 290,
	"./relaiy.png": 324,
	"./resumetail.png": 539,
	"./speedmates.png": 513,
	"./superfastit.jpeg": 395,
	"./techpad.png": 893,
	"./unieats.png": 797,
	"./upwork.png": 200,
	"./yt.png": 255
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 218;